<template>
  <div>
    <!--training image-->
    <v-row justify="center" align="center">
      <v-col>
        <image-uploader
          id="training-image"
          :maxWidth="1024"
          :maxHeight="512"
          :quality="0.9"
          :autoRotate="true"
          outputFormat="blob"
          :preview="false"
          :capture="false"
          accept="image/*"
          doNotResize="['gif', 'svg']"
          @input="onFileSelect"
        >
          <label for="training-image" slot="upload-label">
            <!--training image new-->
            <v-container
              v-if="isEditing && trainingImageUrl"
              fluid
              class="pa-0"
              style="position: relative"
            >
              <v-img
                :src="trainingImageUrl"
                :alt="getLocalisedValue(training.title)"
                :max-height="trainingImageHeight"
                cover
                style="border-radius: 7px"
              />

              <div style="position: absolute; bottom: 20px; right: 20px">
                <v-btn
                  small
                  color="error"
                  min-width="80"
                  class="rounded-1"
                  :disabled="isTrainingImageSaving"
                  @click.prevent="cancelMediaSelection"
                >
                  {{ $t("course.courseDetails.cancel") }}
                </v-btn>
              </div>
            </v-container>

            <!--training image existing-->
            <v-container
              v-else-if="hasContents(training.images)"
              fluid
              class="pa-0"
              style="position: relative"
            >
              <v-img
                :src="getImage(training.images)"
                :alt="getLocalisedValue(training.title)"
                :max-height="trainingImageHeight"
                cover
                style="border-radius: 7px"
                @click.prevent="() => {}"
              >
              </v-img>

              <div
                v-if="isEditing"
                class="v-btn v-size--small primary rounded-1 hand-cursor"
                style="position: absolute; bottom: 20px; right: 20px"
              >
                <v-icon left small color="white">mdi-pencil</v-icon>

                {{ $t("course.courseDetails.edit") }}
              </div>
            </v-container>

            <!--training image empty-->
            <v-container
              v-else
              fluid
              class="fill-height justify-center pa-0"
              style="border: 1px solid #281166; border-radius: 7px"
              :style="`height: ${trainingImageHeight}px`"
            >
              <div
                v-if="isEditing"
                class="
                  v-btn v-btn--outlined v-btn--plain
                  v-size--default
                  textLight--text
                  rounded-1
                  text-capitalize
                  hand-cursor
                "
                style="min-width: 120px; opacity: 0.5"
              >
                <v-icon left>mdi-upload-outline</v-icon>

                {{ $t("course.courseDetails.uploadCoverImage") }}
              </div>
            </v-container>
          </label>
        </image-uploader>
      </v-col>
    </v-row>
    <CropperModal ref="cropperModal" @croppedData="croppedData" />
  </div>
</template>

<script>
import CropperModal from "../../../core-module/components/CropperModal.vue";

export default {
  name: "CourseImage",
  components: {
    CropperModal,
  },
  props: {
    training: {
      type: Object,
      required: true,
    },
    isEditing: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      isTrainingImageSaving: false,
      trainingImage: null,
      trainingImageUrl: null,
    };
  },
  computed: {
    trainingImageHeight() {
      return this.$vuetify.breakpoint.xlOnly
        ? 400
        : this.$vuetify.breakpoint.lgAndUp
        ? 300
        : 250;
    },
  },
  watch: {
    isEditing() {
      this.cancelMediaSelection();
    },
  },
  methods: {
    onFileSelect(file) {
      this.trainingImage = file;

      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        this.trainingImageUrl = reader.result;
        this.$refs.cropperModal.show(this.trainingImageUrl);
      };

      this.$emit("update:training", {
        ...this.training,
        trainingImages: [{ url: this.trainingImage }],
        hasChangesInImages: true,
      });
    },
    croppedData(blobData, base64Data) {
      this.trainingImage = blobData;
      this.trainingImageUrl = base64Data;
      this.$emit("update:training", {
        ...this.training,
        trainingImages: [{ url: this.trainingImage }],
        hasChangesInImages: true,
      });
    },
    cancelMediaSelection() {
      this.trainingImage = null;
      this.trainingImageUrl = null;
      const el = document.getElementById("training-image");
      if (el) el.value = "";

      this.$emit("update:training", {
        ...this.training,
        trainingImages: null,
        hasChangesInImages: false,
      });
    },
  },
};
</script>

<style lang="scss" scoped />
